import React from 'react';
import { TextButton as Button } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { translatedCustomCtaLabel } from '../../../utils/translatedCustomCtaLabel';
import { VendorCtaSelectorProps } from '../VendorCtaSelector';

const RoadsterCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;
  const { actionTypeRoadster, ctaRoadsterLabelEnglish, ctaRoadsterLabelFrench } = ctaDetails;
  const { hasCustomLabel, customLabel } = translatedCustomCtaLabel(
    ctaRoadsterLabelEnglish,
    ctaRoadsterLabelFrench,
    lang,
  );

  // Implemented defaults if no custom label is provided
  const paymentOptionsDefaultLabel = t('vlp.vendorCtaDefaultLabels.roadster.paymentOptions');
  const startBuyingDefaultLabel = t('vlp.vendorCtaDefaultLabels.roadster.startBuying');

  // Choose the default label based on the action type
  // NOTE: actionTypeRoadster values are in english: "See payment options" or "Start buying process"
  const defaultLabel =
    actionTypeRoadster === 'See payment options'
      ? paymentOptionsDefaultLabel
      : startBuyingDefaultLabel;

  const ctaLabel = hasCustomLabel && customLabel ? customLabel : defaultLabel;

  return (
    <Button
      className="roadster-btn"
      variant={variant}
      href={`${ctaDetails?.ctaRoadsterUrl}${vin}`}
      data-testid="roadster"
    >
      {ctaLabel}
    </Button>
  );
};

export default RoadsterCta;
